import { Divider, PageHeader } from 'antd'
import React from 'react'
import { BankAccountFormItem, BankBikFormItem, BankNameFormItem } from '../../Common'
import {
  validateBankAccount,
  validateBankAccountIndividual,
  validateBankAccountSelfEmployed,
  validateBankBik,
  validateFullBankAccount,
  validateTitle
} from '../../../helper'
import { useStores } from '../../../Store/Store'
import { individual, AppConfig } from '../../../AppConfig'
import { errors, profileScreen } from '../../../translates'
import { useLocation } from 'react-router-dom'

const BankDetails = ({ form }) => {
  const {
    partnerProfile: {
      profile,
      required
    } = {}
  } = useStores()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const isCreateKorForm = searchParams.has('action') && searchParams.get('action') === AppConfig.formScreenActions.editInfo
  const isSelfEmpl = React.useMemo(() => {
    return AppConfig.partnerAdditionalRoles.includes(profile?.personalData?.roleCode)
  }, [profile?.personalData?.roleCode])

  const handleChangeBik = () => {
    if (form?.getFieldValue(['bankDetails', profileScreen.input.bankAccount.name])) {
      form.validateFields([['bankDetails', profileScreen.input.bankAccount.name]])
        .catch(() => {})
    }
  }

  if (!profile?.bankDetails?.allowEdit && !(isSelfEmpl && isCreateKorForm)) return null

  return (
    <>
      <PageHeader title={profileScreen.title2} />

      <BankAccountFormItem
        label={profileScreen.input.bankAccount.label}
        placeholder={profileScreen.input.bankAccount.placeholder}
        rules={[
          {
            required: required?.bankDetails,
            message: profileScreen.input.bankAccount.message,
            validator: validateBankAccount
          },
          form => ({
            validator (rule, value) {
              const legalForm = form.getFieldValue(['personalData', profileScreen.input.legalForm.name]) ?? profile?.personalData?.legalForm
              if (legalForm === individual) {
                return validateBankAccountIndividual(rule, value)
              }
              return validateBankAccountSelfEmployed(rule, value)
            }
          }),
          {
            message: errors.bankBikAccount,
            validator: (rule, value) => validateFullBankAccount({
              rule,
              account: value,
              bik: form?.getFieldValue(['bankDetails', profileScreen.input.bankBik.name])
            })
          }
        ]}
        classNameInput='noScrollNumber'
      />

      <BankBikFormItem
        label={profileScreen.input.bankBik.label}
        placeholder={profileScreen.input.bankBik.placeholder}
        rules={[{ required: required?.bankDetails, message: profileScreen.input.bankBik.message, validator: validateBankBik }]}
        classNameInput='noScrollNumber'
        onChange={handleChangeBik}
      />

      <BankNameFormItem
        label={profileScreen.input.bankName.label}
        placeholder={profileScreen.input.bankName.placeholder}
        rules={[{ required: required?.bankDetails, message: profileScreen.input.bankName.message, validator: validateTitle }]}
      />
      <Divider />
    </>
  )
}
export default BankDetails
